import {useNavigate} from "react-router-dom";
import {useUsername} from "../../../utils/utils";
import ApplicationCard from "../../ApplicationCard/ApplicationCard";
import {longDate} from "../../../utils/datoUtil";
import {PktButton} from "@oslokommune/punkt-react";
import {PRIS_SØKNADER_ROUTE} from "../../../routes";
import React from "react";

type Props = {
    mottattDato: string;
}

export default function InnsendtPrissøknad({mottattDato}: Props) {
    const navigate = useNavigate()
    const userName = useUsername()
    return (
        <ApplicationCard title={userName ?? ""} variant={"gul"}>
            <div
                className={"pkt-txt-16-light"}>Vi mottok søknaden din om redusert
                barnehagepris {longDate(mottattDato)}.


                Du kan følge med på behandlingen av søknaden og ettersende vedlegg ved behov.
            </div>
            <PktButton onClick={() => navigate(PRIS_SØKNADER_ROUTE)} size={"small"}
                       className={"mt-size-16"}>
                Se status
            </PktButton>
        </ApplicationCard>
    )
}

